import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchPortalContact } from '../lib/db';
import { supabase } from '../services/supabaseClient';

const PortalContext = createContext(null);

export const PortalProvider = ({ children }) => {
  const [contact, setContact]   = useState(null);
  const [firm,    setFirm]      = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: contactRow } = await fetchPortalContact();
      if (cancelled) return;
      setContact(contactRow || null);

      // The contact RPC returns only the contacts row — no joined firm.
      // Use the dedicated SECURITY DEFINER RPC (migration 084) to read public
      // firm branding fields (name, logo_url, email, phone, address). Portal
      // clients can't read the firms table directly because they don't have a
      // public.users row, so current_firm_id() returns NULL and RLS blocks
      // them — the RPC bypasses that for branding only.
      let firmRow = contactRow?.firm || null;
      if (!firmRow) {
        const { data: branding, error: bErr } = await supabase
          .rpc('get_firm_branding_for_portal_user');
        if (!bErr) {
          const row = Array.isArray(branding) ? branding[0] : branding;
          firmRow = row || null;
        }
      }
      if (cancelled) return;
      setFirm(firmRow);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <PortalContext.Provider value={{ contact, firm, loading }}>
      {children}
    </PortalContext.Provider>
  );
};

export const usePortal = () => {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error('usePortal must be used inside PortalProvider');
  return ctx;
};
